<template>
  <div class="groupProduct">
    <div class="screen">
      <router-link :to="{ path: '/apply/GoodsGroup/4/createGroup' }">
        <el-button type="primary" size="small">创建团购项目</el-button>
      </router-link>
      <router-link :to="{ path: '/apply/GoodsGroup/4/LibraryOfGoods' }">
        <el-button type="primary" size="small">商品库</el-button>
      </router-link>
      <el-select v-model="value" placeholder="请选择" size="small">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-input v-model="input" placeholder="请输入内容" size="small"></el-input>
      <el-button type="primary" size="small">查询</el-button>
    </div>
    <template>
      <el-tabs v-model="activeName">
        <el-tab-pane label="全部项目" name="1">
          <div class="tables">
            <template>
              <el-table :data="tableData" style="width: 100%">
                <el-table-column prop="date" label="项目ID" min-width="180"></el-table-column>
                <el-table-column prop="name" label="项目名称" min-width="180"></el-table-column>
                <el-table-column prop="name" label="销量" min-width="180"></el-table-column>
                <el-table-column prop="name" label="最近变更时间" min-width="180"></el-table-column>
                <el-table-column prop="name" label="项目名称" min-width="180"></el-table-column>
                <el-table-column prop="name" label="操作" min-width="180"></el-table-column>
              </el-table>
            </template>
          </div>
        </el-tab-pane>
        <el-tab-pane label="待上线项目" name="2">
          <div class="tables">
            <template>
              <el-table :data="tableData" style="width: 100%">
                <el-table-column prop="date" label="项目ID" min-width="180"></el-table-column>
                <el-table-column prop="name" label="项目名称" min-width="180"></el-table-column>
                <el-table-column prop="name" label="销量" min-width="180"></el-table-column>
                <el-table-column prop="name" label="最近变更时间" min-width="180"></el-table-column>
                <el-table-column prop="name" label="项目名称" min-width="180"></el-table-column>
                <el-table-column prop="name" label="操作" min-width="180"></el-table-column>
              </el-table>
            </template>
          </div>
        </el-tab-pane>
        <el-tab-pane label="已上线项目" name="3">
          <div class="tables">
            <template>
              <el-table :data="tableData" style="width: 100%">
                <el-table-column prop="date" label="项目ID" min-width="180"></el-table-column>
                <el-table-column prop="name" label="项目名称" min-width="180"></el-table-column>
                <el-table-column prop="name" label="销量" min-width="180"></el-table-column>
                <el-table-column prop="name" label="最近变更时间" min-width="180"></el-table-column>
                <el-table-column prop="name" label="项目名称" min-width="180"></el-table-column>
                <el-table-column prop="name" label="操作" min-width="180"></el-table-column>
              </el-table>
            </template>
          </div>
        </el-tab-pane>
        <el-tab-pane label="已下线项目" name="4">
          <div class="tables">
            <template>
              <el-table :data="tableData" style="width: 100%">
                <el-table-column prop="date" label="项目ID" min-width="180"></el-table-column>
                <el-table-column prop="name" label="项目名称" min-width="180"></el-table-column>
                <el-table-column prop="name" label="销量" min-width="180"></el-table-column>
                <el-table-column prop="name" label="最近变更时间" min-width="180"></el-table-column>
                <el-table-column prop="name" label="项目名称" min-width="180"></el-table-column>
                <el-table-column prop="name" label="操作" min-width="180"></el-table-column>
              </el-table>
            </template>
          </div>
        </el-tab-pane>
      </el-tabs>
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: "1",
      tableData: [],
      options: [
        {
          value: "选项1",
          label: "黄金糕"
        },
        {
          value: "选项2",
          label: "双皮奶"
        },
        {
          value: "选项3",
          label: "蚵仔煎"
        },
        {
          value: "选项4",
          label: "龙须面"
        },
        {
          value: "选项5",
          label: "北京烤鸭"
        }
      ],
      value: ""
    };
  },
  mounted() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
.groupProduct {
  width: 100%;
  padding: 15px 25px;
  height: 100%;
  overflow: auto;
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.1);
  .screen {
    display: flex;
    flex-direction: row;
    margin-bottom: 25px;
    .el-button,
    .el-select,
    .el-input {
      margin-right: 10px;
    }
    .el-input {
      width: 200px;
    }
  }
  .tables {
    width: 100%;
    border: 1px solid #ebeef5;
  }
}
</style>

<style lang="scss">
.groupProduct {
  .cell {
    text-align: center;
  }
}
</style>
